import FooterCalloutRepository from "../FooterCalloutRepository"

export default class FaqFooterCallout extends FooterCalloutRepository {
    static schemaId = "faq_footerCallout"

    constructor() {
        super(FaqFooterCallout.schemaId)
    }
}
